import React, { useState } from 'react';

import axios from '../../../sharedModules/utils/axios.utils';

interface NavigationContextInterface {
  badgeCountsErrorMessage?: string;
  fetchBadgeCounts?: (module: string) => void;
  badgeCountsLoading?: boolean;
  badgeDisplayValues?: any;
}

interface NavigationContextProviderProps {
  children: React.ReactNode;
}

const NavigationContext = React.createContext<NavigationContextInterface>({});

const NavigationContextConsumer = NavigationContext.Consumer;
const NavigationContextProvider: React.FC<NavigationContextProviderProps> = ({ children }) => {
  const [badgeCountsErrorMessage, setBadgeCountsErrorMessage] = useState<string>('');
  const [badgeCountsLoading, setBadgeCountsLoading] = useState<boolean>(false);
  const [badgeDisplayValues, setBadgeDisplayValues] = useState<any>({});

  const badgeOrNothing = (n?: number) => {
    return n && n > 0 ? String(n) : undefined;
  };

  const fetchBadgeCounts = async (module: string) => {
    setBadgeCountsLoading(true);

    try {
      const response: any = await axios.get('/badge_counts', { params: { module: module } });
      const raw = response.data;

      const processed: any = {};
      for (const key in raw) {
        const value = raw[key];
        processed[key] = badgeOrNothing(value);
      }

      setBadgeDisplayValues(processed);

      setBadgeCountsErrorMessage('');
    } catch (error) {
      setBadgeCountsErrorMessage('Error fetching Badge Counts');
    } finally {
      setBadgeCountsLoading(false);
    }
  };

  return (
    <NavigationContext.Provider
      value={{
        badgeDisplayValues,
        badgeCountsErrorMessage,
        badgeCountsLoading,
        fetchBadgeCounts,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export { NavigationContextProvider, NavigationContextConsumer, NavigationContext };
